import {initialState} from "./initialState";

export default function disabledReducer(state = initialState.disabled, action) {
  switch (action.type) {
    default:
      return state;
  }
}